<template>
  <section class="company-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">关于我们</h2>
        <p class="section-subtitle">汇聚精英团队，引领AI技术创新</p>
      </div>
      
      <div class="company-content-wrapper">
        <div class="company-image">
          <div class="team-icon">
            <i class="fas fa-users"></i>
          </div>
          <h3 class="team-title">弦动魔方团队</h3>
        </div>
        
        <div class="company-text-content">
          <p class="company-desc">弦动魔方科技有限公司是一家专注于人工智能领域的前沿科技型企业，致力于AI大模型训练、微调定制以及软件应用和硬件应用开发。</p>
          
          <p class="company-desc">我们的技术团队汇聚了AI算法专家、系统架构师和产品研发精英，多人拥有顶尖科研机构和知名企业工作经历。团队核心成员平均拥有多年人工智能领域实战经验，主导过多个大型AI项目落地，发表过数十篇行业论文，并持有多项人工智能相关专利。我们的的学科背景和多元化专业构成，使团队在面对复杂技术挑战时能够提供独特视角和创新解决方案，为弦动魔方的技术创新与行业突破奠定了坚实基础。</p>
        </div>
      </div>
      
      <div class="value-blocks">
        <div class="value-block">
          <div class="value-icon">
            <i class="fas fa-brain"></i>
          </div>
          <h3 class="value-title">技术驱动</h3>
          <p class="value-desc">以前沿AI研发为核心，持续推动技术突破与创新</p>
        </div>
        
        <div class="value-block">
          <div class="value-icon">
            <i class="fas fa-handshake"></i>
          </div>
          <h3 class="value-title">客户至上</h3>
          <p class="value-desc">深入理解客户需求，提供定制化的智能解决方案</p>
        </div>
        
        <div class="value-block">
          <div class="value-icon">
            <i class="fas fa-rocket"></i>
          </div>
          <h3 class="value-title">未来愿景</h3>
          <p class="value-desc">致力于开发高性能AI硬件产品，造福社会大众</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CompanySection'
}
</script>

<style scoped>
.company-section {
  position: relative;
  padding: 6rem 0;
  background-color: #1f1a36;
  overflow: hidden;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #b59eff;
  background: linear-gradient(135deg, #b59eff 0%, #9d6efd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #b3b3cc;
  max-width: 600px;
  margin: 0 auto;
}

.company-content-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 3rem;
  margin-bottom: 4rem;
}

.company-image {
  width: 300px;
  background-color: #28223e;
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  border: 1px solid rgba(157, 110, 253, 0.2);
}

.team-icon {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, rgba(157, 110, 253, 0.2) 0%, rgba(157, 110, 253, 0.4) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
}

.team-icon i {
  font-size: 3rem;
  color: #b59eff;
}

.team-title {
  font-size: 1.4rem;
  color: #ffffff;
  font-weight: 600;
}

.company-text-content {
  flex: 1;
}

.company-desc {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #b3b3cc;
  margin-bottom: 1.5rem;
}

.value-blocks {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
}

.value-block {
  flex: 1;
  background-color: #28223e;
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  border: 1px solid rgba(157, 110, 253, 0.2);
  transition: all 0.3s ease;
}

.value-block:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 30px rgba(157, 110, 253, 0.2);
  border-color: rgba(157, 110, 253, 0.4);
}

.value-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #9D6EFD 0%, #E879F9 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
}

.value-icon i {
  font-size: 1.8rem;
  color: white;
}

.value-title {
  font-size: 1.3rem;
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 1rem;
}

.value-desc {
  font-size: 1rem;
  color: #b3b3cc;
  line-height: 1.6;
}

@media screen and (max-width: 992px) {
  .company-content-wrapper {
    flex-direction: column;
    align-items: center;
  }
  
  .company-image {
    width: 100%;
    max-width: 300px;
    margin-bottom: 2rem;
  }
  
  .value-blocks {
    flex-direction: column;
  }
}

@media screen and (max-width: 768px) {
  .section-title {
    font-size: 2rem;
  }
  
  .section-subtitle {
    font-size: 1rem;
  }
  
  .company-desc {
    font-size: 1rem;
  }
}
</style> 